import { render, staticRenderFns } from "./WarningsText.vue?vue&type=template&id=595d8f21&"
import script from "./WarningsText.vue?vue&type=script&lang=js&"
export * from "./WarningsText.vue?vue&type=script&lang=js&"
import style0 from "./WarningsText.vue?vue&type=style&index=0&id=595d8f21&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595d8f21')) {
      api.createRecord('595d8f21', component.options)
    } else {
      api.reload('595d8f21', component.options)
    }
    module.hot.accept("./WarningsText.vue?vue&type=template&id=595d8f21&", function () {
      api.rerender('595d8f21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/NewServiceForm/components/WarningsText.vue"
export default component.exports